export default __webpack_public_path__ + "static/media/YAS0810.34I-37990_-25051_0.57bebcfb.jpg";